<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานแสดงการรับ-ส่งข้อมูลในบล็อกเชน (BlockChain)
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>รายงานแสดงการรับ-ส่งข้อมูลในบล็อกเชน (BlockChain)
          </a>
        </li>
        <!-- <li class="active">การจัดกลุ่มผู้ให้บริการ</li> -->
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทการให้บริการ" prop="provider_type">
                            <el-select 
                              filterable 
                              v-model="form.service_type" 
                            >
                              <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                              <el-option
                                label="อินเทอร์เน็ตความเร็วสูงประจำที่"
                                value="broadband"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="Txn Hash">
                            <el-input
                              clearable
                              v-model="form.transaction_code"
                              placeholder="Txn Hash : 0x380d5182ade2aa69e247d97945130bf0ae4910891c4247c0c132e1e3df771922"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="Address">
                            <el-input
                              clearable
                              v-model="form.address"
                              placeholder="Address : 0xdB329839D1A45F70a32d3a325f112067Fc0BD215"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="Date">
                            <el-date-picker
                                v-model="form.date"
                                type="daterange"
                                range-separator="ถึง"
                                start-placeholder="วันที่เริ่มต้น"
                                end-placeholder="วันที่สิ้นสุด"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <div class="layout_filter_btn">
                        <button type="button" class="btn btn-primary" @click="loadData(null, form)">ค้นหา</button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="wrapper_typegroup">
                  <data-tables-server 
                    @query-change="loadData" 
                    :current-page.sync="page"
                    :data="transaction" style="width: 100%"
                    :total="total"
                    :page-size="10"
                    :pagination-props="{
                      background: true,
                      pageSizes: [10, 20, 50]
                    }"
                  >
                    <el-table-column prop="transaction_code" label="Txn Hash" width="280">
                      <template slot-scope="scope">
                        <el-link
                          type="primary"
                          @click="openDialogTxn(scope.row)"
                          :underline="false"
                        >{{scope.row.transaction_code}}</el-link>
                      </template>
                    </el-table-column>
                    <el-table-column prop="block_number" label="Block" width="100">
                    </el-table-column>
                    <el-table-column prop="created_at" label="Date" width="240">
                      <template slot-scope="scope">
                        {{ moment(scope.row.created_at).add(543, 'Y').format('DD-MM-YYYY HH:mm:ss') }}
                      </template>
                    </el-table-column>
                    <el-table-column prop="from_address" label="From" width="300">
                      <template slot-scope="scope">
                      {{scope.row.from_address}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="to_address" label="TO" width="300">
                      <template slot-scope="scope">
                        {{scope.row.to_address}}
                      </template>
                    </el-table-column>
                  </data-tables-server>
                  <!-- <Modal_txn :data="dialogData" :dialog="dialog" @checkModal="closeModal"></Modal_txn> -->
                  <Modal_data :service_type="current_service_type" :info="dialogData" :dialog="dialog" :rowInfo="rowData" @checkModal="closeModal"></Modal_data>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import Modal_txn from "../Modal/Modal_txn";
import Modal_data from "../Modal/Modal_data_blockchain";
import { mapState,mapActions} from "vuex"
import moment from "moment"
export default {
  components: {
    Modal_txn: Modal_txn,
    Modal_data: Modal_data
  },
  created(){
      // this.$store.dispatch('Report_blockchain/getBlockchainTransaction')
  },
  data() {
    return {
      page: 1,
      dialog: false,
      loading: false,
      current_service_type: this.service_type || '',
      label_position: "top",
      form: {
        transaction_code: "",
        address: "",
        service_type: "mobile",
        date: []
      },
      dialogData: {},
      rowData: {},
      dialogVisible: false,
      type: null,
      tableData: {
        border: true
        // stripe: true,
      },
      // tableData: [
      //   {
      //     txn:
      //       "0x6d1ce6037b1f45c8877f595318f21761b53eca9a2dd5a72c5931e8948444a8f5",
      //     blocknumber: "8172512",
      //     age_txn: "Jul-18-2019 04:24:57",
      //     address_from: "0xdB329839D1A45F70a32d3a325f112067Fc0BD215",
      //     address_to: "0xE57Dac21f4c70D7Ff52Ad44Eb6327203f7b5e5C6"
      //   },
      //   {
      //     txn:
      //       "0x3ab18e847e2bfc559e7f27a0943b0ab2e16142e2f1f6cb1b6d516695cacfee9f",
      //     blocknumber: "8172512",
      //     age_txn: "Jul-18-2019 04:45:05",
      //     address_from: "0xdB329839D1A45F70a32d3a325f112067Fc0BD215",
      //     address_to: "0xE57Dac21f4c70D7Ff52Ad44Eb6327203f7b5e5C6"
      //   },
      //   {
      //     txn:
      //       "0x259b1f57326c4b374f144c6a31868498685382bafda9f3abc5dbd50ec1ffac72",
      //     blocknumber: "8172512",
      //     age_txn: "Jul-18-2019 04:48:56",
      //     address_from: "0xdB329839D1A45F70a32d3a325f112067Fc0BD215",
      //     address_to: "0xE57Dac21f4c70D7Ff52Ad44Eb6327203f7b5e5C6"
      //   },
      //   {
      //     txn:
      //       "0x28454daa4b5050d1d5badba93136f231c5c307796af70347a4ea0b5fa0517a21",
      //     blocknumber: "8172617",
      //     age_txn: "Jul-18-2019 04:48:56",
      //     address_from: "0xdB329839D1A45F70a32d3a325f112067Fc0BD215",
      //     address_to: "0xE57Dac21f4c70D7Ff52Ad44Eb6327203f7b5e5C6"
      //   }
      // ]
    };
  },
  computed: {
    ...mapState({
      transaction: store => store.Report_blockchain.transaction,
      total: store => store.Report_blockchain.total,
      service_type: store => store.Report_blockchain.service_type,
      data_detail: store => store.Report_blockchain.data_detail
    })
  },
  mounted() {},
  watch: {
    data_detail: {
      handler : function(reload, empty){
        this.current_service_type = this.service_type
        this.loading = false
        this.dialogData = reload
        this.dialog = true
      }
    }
  },
  methods: {
    ...mapActions({
      getTransaction: "Report_blockchain/getBlockchainTransaction",
      checkTransection: "Report_blockchain/checkTransection"
    }),
    closeModal(value) {
      this.dialog = value;
    },
    openDialogTxn(row) {
      this.checkTransection(row.transaction_code)
      this.rowData = row
      this.loading = true
    },
    loadData(queryInfo, form) {
      if (queryInfo) {
        let set_data = {
          page: queryInfo.page,
          pageSize: queryInfo.pageSize,
          form: this.form
        };
        this.getTransaction(set_data);
      } else {
        let set_data = { page: 1, pageSize: 10, form: form };
        this.page = 1
        this.getTransaction(set_data);
      }
    },
  }
};
</script>
